import Show from './MyInformationShow'
import Edit from './MyInformationEdit'

const myInformation = {
  Show,
  Edit,
}

export default myInformation
